/**
 * Reads a deploy-time REPLACEME variable.
 *
 * Lives here rather than in `utils` because the constants barrel is the first module the OIDC
 * bootstrap pulls in: importing this from `utils` dragged that whole graph - `tokenManager`
 * included - into the barrel's own initialisation, so `tokenManager`'s module-scope
 * `LOCAL_STORAGE` read ran before the barrel had wired that re-export up.
 */
export function createReplaceVariable(variableName) {
    if (process.env.NODE_ENV === 'production') {
        if (variableName.includes('REPLACEME')) {
            throw new Error(variableName + ' missing from deploy env.');
        }
        return variableName;
    } else {
        return process.env[variableName];
    }
}
